// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"419":"027c13b6","645":"594c1e8b"}[chunkId] + ".chunk.js";
};